import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SortableTable } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})

export class AvizareTauriService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/`,
      req_params
    ).pipe(
        map((response: any) => {
          this.totalRecords = response.count;
          this.paginate();

          return response;
        }));
  }

  listAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/list/`,
      req_params
    ).pipe(
        map((response: any) => {
          this.totalRecords = response.count;
          this.paginate();

          return response;
        }));
  }

  listaTauriAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/lista_tauri/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  creazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/creaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  salveazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/salveaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  stergeAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/sterge/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  finalizeazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/finalizeaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  anuleazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/anuleaza/`,
      req_params
    ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  downloadAPI(id) {
    return this.http.get(
      `${this.baseUrl}/documente/avizare_tauri/download/${id}`,
        {
          responseType: 'blob'
        }
      );
  }

  exportAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/documente/avizare_tauri/export/`,
        req_params,
        {
          responseType: 'blob'
        }
      );
  }

  private paginate(): void {
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.totalRecords) {
      this._state.endIndex = this.totalRecords;
    }
  }
}
